
import React from "react";
import { formatNumber } from "../utils/chartUtils";

type CustomTooltipProps = {
  active?: boolean;
  payload?: any;
  label?: string;
  title: string;
  hasData: boolean;
};

export const CustomTooltip = ({ active, payload, label, title, hasData }: CustomTooltipProps) => {
  if (active && payload && payload.length && hasData) {
    return (
      <div className="bg-secondary/95 border border-primary/20 p-2 rounded-lg shadow-lg">
        <p className="text-primary font-semibold">{`Year: ${label}`}</p>
        <p className="text-primary-light">{`${title}: ${formatNumber(payload[0].value)}`}</p>
      </div>
    );
  }
  return null;
};
